import { observer } from 'mobx-react';
import propTypes from 'prop-types';

import { SubstitutionSectionHeader } from './SubstitutionSectionHeader/SubstitutionSectionHeader.jsx';
import { SubstitutionProduct } from './SubstitutionProduct/SubstitutionProduct.jsx';
import { SubstitutionGroup } from './SubstitutionGroup/SubstitutionGroup.jsx';
import { SubstitutionRange } from './SubstitutionRange/SubstitutionRange.jsx';

export const _SubstitutionSection = (props) => {
  const { parentSkuID, substSectionStore, endOfSale, isLabelRef } = props;

  const sectionType = substSectionStore.sectionType || 'absent';

  const getSectionContent = () => {
    switch (sectionType) {
      case 'product':
        return <SubstitutionProduct product={substSectionStore.products[0]} substStore={substSectionStore} />;
      case 'group':
        return <SubstitutionGroup products={substSectionStore.products} substStore={substSectionStore} />;
      case 'range':
        return <SubstitutionRange range={substSectionStore.range} />;
      default:
        return '';
    }
  };

  const sectionContent = getSectionContent();
  const renderHeader = sectionType === 'group' || isLabelRef || endOfSale;

  if (sectionContent || renderHeader) {
    return (
      <div className="subst-section">
        {renderHeader && (
          <SubstitutionSectionHeader
          parentSkuID={parentSkuID}
          type={sectionType}
          substStore={substSectionStore}
          endOfSale={endOfSale}
          isLabelRef={isLabelRef}
          />
        )}
        {sectionContent
        && (
          <div className="subst-section__content">
            {sectionContent}
          </div>
        )}
      </div>
    );
  }

  return null;
};

_SubstitutionSection.propTypes = {
  parentSkuID: propTypes.string.isRequired,
  substSectionStore: propTypes.object,
  endOfSale: propTypes.bool,
  isLabelRef: propTypes.bool
};

_SubstitutionSection.defaultProps = {
  substSectionStore: {}
};

export const SubstitutionSection = observer(_SubstitutionSection);
